<div [hidden]="!includeLabel">
    <label for="{{name}}">{{getLabelName()}}</label>
</div>

<ng-container *ngIf="items && items.length > 0">
    <div class="row" *ngIf="this.showSelectAll">
        <div class="col-12">
            <input class="ms-3 me-2" type="checkbox" name="" id="" (click)="this.selecionarTodos($event)">
            <span>Selecionar Todos</span>
        </div>
    </div>
    <div class="row border rounded mx-1 py-1 select-input overflow-auto">
        <div [ngClass]="'col-' + 12 / this.cols" *ngFor="let item of items">
            <input type="checkbox" class="me-2" [value]="item.id" [name]="item.nome"
                (click)="this.mudarValor($event, item.id, item.nome, item.complementar)"
                [checked]="(this.existeItemSelecionado(item.id) ? 'checked' : '')" [disabled]="detailMode" />
            <span>{{item.nome}}</span><br />
        </div>
    </div>
</ng-container>
<ng-container *ngIf="items && keyItems.length > 0">
    <div class="row">
        <div class="col-12">
            <input class="ms-3 me-2" type="checkbox" name="" id="" (click)="this.selecionarTodos($event)">
            <span>Selecionar Todos</span>
        </div>
    </div>
    <div class="row border rounded mx-1 py-1 select-input overflow-auto">
        <div [ngClass]="'col-' + 12 / this.cols" *ngFor="let item of keyItems">
            <input type="checkbox" class="me-2" [value]="item.key" [name]="item.value"
                (click)="this.mudarValor($event, item.key, item.value, '')"
                [checked]="(this.existeItemSelecionado(item.key) ? 'checked' : '')" [disabled]="readOnly" />
            <span>{{item.value}}</span><br />
        </div>
    </div>
</ng-container>

<div *ngIf="!detailMode">
    <app-input-feedback [hidden]="!this.validarObrigatorio()" [feedbackMessage]="spanRequired"></app-input-feedback>
</div>